import { useCallback } from "react";
import FilterIcon from "../../../icons/FilterIcon";
import SearchIcon from "../../../icons/SearchIcon";
import DownloadIcon from "@mui/icons-material/Download";
import Button from "../../../toolkit/ButtonV1";
import FormControl from "../../../components/FormControl";

import React, { useMemo, useState } from "react";
import _ from "lodash";
import { Divider, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import "../../../Localization/i18n";
import { Card, Grid, Box } from "@mui/material";
import { useEffect } from "react";
import PlusIcon from "../../../icons/PlusIcon";
import Dialog from "@mui/material/Dialog";
// import Adduser from "./Adduser";
import axios from "../../../utils/fvAxios";
import fileDownload from "js-file-download";
import ExportToExcel from "../../../utils/ExportToExcel";

const searchDebounceDelay = 1000;

export default function TemplateCollectionControls({
  searchStr: parentSearchStr,
  setSearchStr: parentSetSearchStr,
  viewType,
  toggleViewType,
  openSlidingPopup,
  largeScreen,
  downloadUrl,
  fileName,
  sheetName,
}) {
  const [searchStr, setSearchStr] = useState(parentSearchStr);
  const [open, setOpen] = useState(false);

  function optionsDataMapper({ key, value }) {
    return {
      value: key,
      text: value,
    };
  }

  const debouncedSearchQueryHandler = useCallback(
    _.debounce(parentSetSearchStr, searchDebounceDelay),
    []
  );

  useEffect(() => {
    if (parentSearchStr !== searchStr) {
      debouncedSearchQueryHandler(searchStr);
    }
  }, [searchStr]);

  const { t } = useTranslation();

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const onUserSearch = () => {
    // onUserSearchClick();
  };

  return (
    <Card style={{ marginBottom: "1rem", border: "none" }}>
      <Box
        className="mt-3"
        style={{ padding: "16px" }}
        sx={{ "& h1": { m: 0 } }}
      >
        <Grid
          container
          wrap="nowrap"
          sx={{ flexDirection: { xs: "column", md: "row", oveflow: "auto" } }}
          spacing={1}
          justify="flex-start"
        >
          <Grid item xs={3}>
            <FormControl
              inputType="text"
              placeholder="Search"
              value={searchStr}
              handleChange={setSearchStr}
              setValidate={() => {}}
            />
          </Grid>
         
        </Grid>
      </Box>
    </Card>
  );
}
